import { TaggedNumberInput, TaggedSelect } from '@components/inputs';
import TaggedModal from '@components/TaggedModal';
import { useUpdateGradingLimit } from '@modules/gradingLimits/src/gradingLimitsMutations';
import { Descriptions, Form } from 'antd';

interface UpdateGradingLimitsModalProps {
  showModal: boolean;
  closeModal: () => void;
  selectedGrade: GradingLimits.GradingLimitsList;
  themes: Inputs.SelectOption[];
}

const UpdateGradingLimitsModal = (props: UpdateGradingLimitsModalProps) => {
  const {
    showModal, closeModal, selectedGrade, themes,
  } = props;

  const { mutate, isLoading } = useUpdateGradingLimit(closeModal);

  const onSubmit = (values: GradingLimits.UpdateGradingLimitPayload) => {
    mutate(values);
  };

  return (
    <TaggedModal
      tag="updateGradingLimits"
      title="Update Grading Limits"
      centered
      destroyOnHidden
      open={showModal}
      okText="Submit"
      okButtonProps={{ htmlType: 'submit', form: 'updateGradingLimitsForm', loading: isLoading }}
      onCancel={closeModal}
      width="30%"
    >
      <Descriptions labelStyle={{ fontWeight: 'bold' }} title={`Grade: ${selectedGrade.grade}`} />
      <Form id="updateGradingLimitsForm" onFinish={onSubmit} initialValues={selectedGrade} layout="vertical">
        <Form.Item name="gradingId" hidden required />
        <Form.Item
          name="suggestedAbsoluteLimit"
          label="Suggested Absolute Limit:"
          rules={[
            {
              required: true,
              message: 'Please fill here.',
            },
          ]}
        >
          <TaggedNumberInput width="10%" tag="suggestedAbsoluteLimit" />
        </Form.Item>
        <Form.Item
          name="suggestedLimitPercentage"
          label="Suggested % Limit:"
          rules={[
            {
              required: true,
              message: 'Please fill here.',
            },
          ]}
        >
          <TaggedNumberInput width="10%" tag="suggestedLimitPercentage" />
        </Form.Item>
        <Form.Item label="Theme:" name="suggestedThemeId" rules={[{ required: true, message: 'Please select a theme.' }]}>
          <TaggedSelect tag="selectTheme" options={themes || []} placeholder="Choose a theme." />
        </Form.Item>
      </Form>
    </TaggedModal>
  );
};

export default UpdateGradingLimitsModal;
